module.exports = __webpack_public_path__ + "static/media/orphee2.479a7ca3.JPG";